/**
 * API 클라이언트 공통 설정 - Phase 3.1 UX 안전 (타임아웃)
 * 모든 fetch에 AbortSignal.timeout 적용 시 사용
 */
export const API_REQUEST_TIMEOUT_MS = 30_000;
